import {User} from "./user/user.js";
import {ACCESS_TYPE} from "./constant.js";

let user = null;
let access = ACCESS_TYPE.BROWSER;
const checkGtmEvent = []
export const initAccess = (curAccess = ACCESS_TYPE.BROWSER) => {
    access = curAccess
}
export const isWebView = () => {
    return !!window?.isWebViewAccess;
}

export const collectGtm =  (eventName = "", userId = "" , isSuffix =  true) => {
    if (Mutil.empty(eventName)) return;
    if (!isInitUser()) {
        return;
    }
    const finalEventName = isSuffix ? `${eventName}${gtmSuffix(eventName)}` : eventName  ;
    if(checkGtmEvent.includes(finalEventName)) {
        return;
    }
    checkGtmEvent.push(finalEventName);
    const GoogleTagManager = Mutil.requireIIFE("GoogleTagManager");
    GoogleTagManager?.collect({event: `${finalEventName}`, userId,});
}

const gtmSuffix = (eventName = '') => {
    const isJoinCompany = (eventName = '') => eventName.indexOf("joinup") > -1;
    const getJoinCompanyGtmSuffix = (eventName = '') => {
        if(!Often.isGlobal() || !isSnsSignUp()) {
            return '';
        }

        if(eventName === 'new_joinup1_a') {
            return 'b'
        }

         return '_b'
    }

    if(isGuestUser()) {
        return '';
    }

    if(isJoinCompany(eventName)) {
        return getJoinCompanyGtmSuffix(eventName);
    }

    if(isSnsSignUp()) {
        return '_b'
    }

    if(!Often.isGlobal() && eventName !== 'new_signup1') {
        return '_a';
    }

    return ''
}
export const initUser = (isGuest, planId = "") => {
    user = new User(isGuest);
    user.setPlanId(planId);
}
export const addEmail = (email) => {
    checkNull();
    user.setEmail(email);
    addUserId(email);
}
export const addUserId = (userId) => {
    checkNull();
    user.setUserId(userId);
}
export const addUserName = (userName) => {
    checkNull();
    user.setUserName(userName);
}

export const addPassword = (password) => {
    checkNull();
    user.setPassword(password);
}

export const addJobType = (jobType) => {
    checkNull();
    user.setJobType(jobType);
}
export const addMarketingYn = (marketingYn) => {
    checkNull();
    user.setMarketingYn(marketingYn);
}
export const addCompanyName = (companyName) => {
    checkNull();
    user.setCompanyName(companyName);
}
export const addCompanyCategory = (companyCategory) => {
    checkNull();
    user.setCompanyCategory(companyCategory);
}
export const addCompanySubDomain = (subDomain) => {
    checkNull();
    user.setCompanySubDomain(subDomain);
}
export const addHopeCount = (hopeCount) => {
    checkNull();
    user.setHopeCount(hopeCount);
}
export const addServiceType = (serviceType) => {
    checkNull()
    user.setServiceType(serviceType);
}
export const addPhoneNumber = (phoneNumber) => {
    checkNull()
    user.setPhoneNumber(phoneNumber)
}

export const addPhoneAuthCompleted = (state) => {
    checkNull()
    user.setPhoneAuthCompleted(state)
}

export const getEmail = () => {
    checkNull();
    return user.getEmail();
}

export const getUserId = () => {
    checkNull();
    return user.getUserId();
}

export const getUserName = () => {
    checkNull();
    return user.getUserName();
}
export const addJoinUseInttId = (useInttId) => {
    checkNull();
    return user.setJoinUseInttId(useInttId);
}

export const getJoinUseInttId = () => {
    checkNull();
    return user.getJoinUseInttId();
}

export const setAsGuestUser = (isGuest = false) => {
    checkNull()
    return user.setAsGuestUser(isGuest)
}

export const isGuestUser = () => {
    checkNull();
    return user.isGuestUser();
}

export const getUserInfo = () => {
    //@todo 개발 끝나면 삭제
    checkNull();
    return user.toString();
}
export const isSnsSignUp = () => {
    //@todo 개발 끝나면 삭제
    checkNull();
    return user.isSnsSignUp();
}

export const getUser = () => {
    //@todo 개발 끝나면 삭제
    checkNull();
    return user;
}

export const getPlanId = () => {
    checkNull();
    return user.getPlanId();
}

export const getPhoneNumber = () => {
    checkNull()
    return user.getPhoneNumber()
}

export const getPhoneAuthCompleted = () => {
    checkNull()
    return user.getPhoneAuthCompleted()
}

export const getAuthHash = () => {
    checkNull()
    return user.getAuthHash()
}

export const setAuthHash = (authHash) => {
    checkNull()
    return user.setAuthHash(authHash)
}

export const addSnsOauthData = (snsOauthData) => {
    const {
        USER_ID = "",
        ID_GB = "",
        OBJ_CNTS_NM = "",
        EMAIL = "",
        USER_NM = "",
        PRFL_PHTG = "",
    } = snsOauthData;
    checkNull();
    addEmail(EMAIL);
    addUserName(USER_NM);
    addUserId(USER_ID);
    user.setDeviceName(OBJ_CNTS_NM);
    user.setIdGb(ID_GB)
    user.setProfilePhoto(PRFL_PHTG);
}
export const initTestUserInfo = () => {
    initUser(false);
    addEmail("test2022060751@yopmail.com");
    addPassword("test0123!")
    addMarketingYn("Y")
    addJobType("Marketing")
    addJoinUseInttId("BFLOW_300000011273")
}
export const  isInitUser = () => {
    return user !== null;
}
const checkNull = () => {
    if (!isInitUser()) {
        throw new Error("유저를 초기화해주세요");
    }
}